import { render, staticRenderFns } from "./Mobs.vue?vue&type=template&id=e72c7e8a&scoped=true&"
import script from "./Mobs.vue?vue&type=script&lang=js&"
export * from "./Mobs.vue?vue&type=script&lang=js&"
import style0 from "./Mobs.vue?vue&type=style&index=0&id=e72c7e8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e72c7e8a",
  null
  
)

export default component.exports